// src/components/_v3/touristic-site/PricesSection.jsx
import React from 'react';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';
import {parsePriceList} from '../../../utils/touristic_sites/_v3/siteData';
import {Card, Eyebrow, SectionHead} from '../../../_ui/_v3/primitives';

const PriceCardStyled = styled(Card)`
  padding: 1.1rem 1.3rem;
`;

const PriceTableStyled = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: .92rem;

  td {
    padding: .7rem .2rem;
    border-bottom: 1px solid ${props => props.theme.colors.line};
    color: ${props => props.theme.colors.inkSoft};
  }
  tr:last-child td { border-bottom: none; }
  td:first-child { color: ${props => props.theme.colors.ink}; font-weight: 600; }
  td.n {
    text-align: right;
    color: ${props => props.theme.colors.ink};
    font-weight: 700;
    font-variant-numeric: tabular-nums;
  }
`;

const PricesSection = ({site}) => {
  const {t, i18n} = useTranslation(['touristic-site']);
  const prices = parsePriceList(site.price_list, i18n.language);

  if (prices.length === 0) {
    return null;
  }
  return (
    <>
      <SectionHead>
        <Eyebrow>{t('v3.eyebrow.tarifs')}</Eyebrow>
        <h2>{t('v3.section.tarifs')}</h2>
      </SectionHead>
      <PriceCardStyled>
        <PriceTableStyled>
          <tbody>
            {prices.map((price, index) => (
              <tr key={index}>
                <td>{price.label}</td>
                <td className="n">{price.price}€</td>
              </tr>
            ))}
          </tbody>
        </PriceTableStyled>
      </PriceCardStyled>
    </>
  );
};

export default PricesSection;
